// emailEngineService.ts — cliente de la pestaña admin "Correos por situación"
// (motor de correos lifecycle). Re-cableado a lealify-base (A5): cookie de sesión
// del super_admin vía baseApi, en vez del token Firebase contra esapi. Endpoints
// admin-only en /api/admin/emails/* (mismos shapes que antes → AdminEmailsPage intacta).
import { baseApi } from '../api/baseClient';

export interface TemplateStats {
  sent: number;
  shadow: number;
  opened: number;
  clicked: number;
}

export interface EmailOverview {
  mode: 'shadow' | 'live';
  owners: number;
  optOuts: number;
  segments: Record<string, string>;
  segmentCounts: Record<string, number>;
  templates: Record<string, TemplateStats>;
  engineMeta: {
    lastRunDay: string;
    lastSummary: { mode: string; candidates: number; sent: number; errors: number; owners: number };
  } | null;
  cachedAt: number;
}

export interface OwnerLogSummary {
  sent: number;
  shadow: number;
  opened: number;
  clicked: number;
  lastSentAt: number | null;
  lastTemplate: string | null;
  lastStatus: string | null;
}

export interface EmailOwner {
  uid: string;
  email: string;
  name: string;
  businessName: string;
  plan: string;
  segment: string;
  clients: number;
  regDays: number | null;
  idleDays: number | null;
  lastActivityAt: number | null;
  optOut: boolean;
  muteUntil: number | null;
  totalSent: number;
  sentSinceEngagement: number;
  lastEmailAt: number | null;
  log: OwnerLogSummary | null;
}

export interface EmailLogEntry {
  id: string;
  template: string;
  segment: string | null;
  subject: string | null;
  status: string;
  sentAt: number | null;
  openedAt: number | null;
  opens: number;
  clicks: { url: string; at: number | null }[];
  activityAfter: boolean;
}

export const fetchEmailOverview = (refresh = false) =>
  baseApi.get<EmailOverview>(`/admin/emails/overview${refresh ? '?refresh=1' : ''}`);

export const fetchEmailOwners = (segment?: string) =>
  baseApi.get<{ owners: EmailOwner[]; cachedAt: number }>(
    `/admin/emails/owners${segment ? `?segment=${encodeURIComponent(segment)}` : ''}`
  );

export const fetchEmailOwnerDetail = (uid: string) =>
  baseApi.get<{ owner: EmailOwner | null; logs: EmailLogEntry[] }>(
    `/admin/emails/owner/${encodeURIComponent(uid)}`
  );

export const emailOwnerAction = async (
  uid: string,
  action: 'mute' | 'unmute' | 'optout' | 'optin',
  days?: number
): Promise<void> => {
  await baseApi.post(`/admin/emails/owner/${encodeURIComponent(uid)}/action`, { action, days });
};
